import { defineStore } from "pinia";
import { router, routers } from "@/router/index.js";
import { getRolePermissionList } from "@/utils/api/common.js";

export const useCounterStore = defineStore("counter", {
  state: () => ({
    token: "",
    userInfo: {}
  }),
  persist: {
    enabled: true,
    strategies: [
      {
        key: "counter",
        storage: localStorage
      }
    ]
  },
  actions: {
    increment() {
      this.count++;
    },
    addMenu() {
      getRolePermissionList().then(({ data }) => {
        let list = routers[0];
        let child = [];
        data.map(item => {
          list.children.map(ite => {
            if (item.name == ite.name && item.operation === 1) {
              child.push({
                ...ite,
                meta: {
                  menu: item.menus_detail ? item.menus_detail.split(",") : []
                }
              });
            }
          });
        });
        list.children = child;
        router.options.routes = [...list, ...router.options.routes];
        router.addRoutes([list]);
        if (localStorage.getItem("nowPath")) {
          router.push(localStorage.getItem("nowPath"));
        } else {
          router.push("/restaurantList");
        }
      });
    },
    decrement() {
      this.count--;
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js